<div class="main-container">

  <div class="title">
    <span class="title-text">Utsav Management</span>
    <p class="small-title">Central utsav instances. New utsavs save inactive until activated.</p>
  </div>

  @if(canManage){
  <div class="header-actions">
    <button type="button" class="ac-primary-btn" (click)="openForm(null)">Add Utsav</button>
  </div>
  }

  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr>
          <th>Title</th>
          <th>Abbrev</th>
          <th>Year</th>
          <th>Location</th>
          <th>Start</th>
          <th>End</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for(u of utsavs; track u.utsavInstanceId){
        <tr>
          <td>{{ u.title }}</td>
          <td>{{ u.abbrev || '-' }}</td>
          <td>{{ u.year || '-' }}</td>
          <td>{{ u.location || '-' }}</td>
          <td>{{ u.startDate || '-' }}</td>
          <td>{{ u.endDate || '-' }}</td>
          <td>{{ u.status }}</td>
          <td class="actions-cell">
            @if(canManage){ <button type="button" class="ac-secondary-small-btn" (click)="openForm(u)">Edit</button> }
            @if(canActivate && u.status !== 'ACTIVE'){ <button type="button" class="ac-secondary-small-btn" (click)="activate(u)">Activate</button> }
            <button type="button" class="ac-secondary-small-btn" (click)="openReports(u)">Reports</button>
          </td>
        </tr>
        }
        @if(!isLoading && utsavs.length === 0){
        <tr>
          <td colspan="8" class="empty-row">No utsavs found.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
